module.exports = __webpack_public_path__ + "assets/img/9d25345d0c1f2c31e4f0be3b66e6753c.png";